/** Authenticated boundary for the isolated WhatsApp feature. */
export async function whatsappRequest(user, path, { method = 'GET', body, signal } = {}) {
  const token = await user.getIdToken();
  const response = await fetch(`/api/v1/whatsapp/${path}`, {
    method, signal,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(typeof payload.detail === 'string' ? payload.detail : 'Could not update WhatsApp. Please try again.');
  }
  return payload;
}
